"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIsFileOptimizableImage;

var _immutable = require("immutable");

var _Constants = require("FileManagerCore/Constants");

var _getIsFileAccessibleAnonymously = _interopRequireDefault(require("FileManagerCore/utils/getIsFileAccessibleAnonymously"));

function getIsFileOptimizableImage(file) {
  return _immutable.Map.isMap(file) && parseInt(file.get('width'), 10) > 0 && file.get('type') === _Constants.FileTypes.IMG && file.get('encoding') !== 'svg' && (0, _getIsFileAccessibleAnonymously.default)(file);
}

module.exports = exports.default;